import Dashboard from '../../views/Dashboard/Dashboard';
import RedirectDashboardOrHomeAdmin from '../../views/Dashboard/RedirectDashboardOrHomeAdmin';
import Contexto from '../../views/Contexto/Contexto';
import Candidato from '../../views/Candidato/Candidato';
import Documento from '../../views/Documento/Documento';
import Email from '../../views/Email/Email';
import RelatorioDependenciasAdministrativas from '../../views/Relatorio/DependenciasAdministrativas';
import RelatorioMunicipios from '../../views/Relatorio/Municipios';
import RelatorioMunicipiosResidenciais from '../../views/Relatorio/MunicipiosResidenciais';
import RelatorioUfs from '../../views/Relatorio/Ufs';
import RelatorioInscricoes from '../../views/Relatorio/QuantitativoInscricoes';
import Banner from '../../views/Banner/Banner';
import Graficos from "../../views/Graficos/Graficos";
import Prova from "../../views/Prova/Prova";
import ProvaInvalida from "../../views/Prova/ProvaInvalida";
import Digitacao from "../../views/Digitacao/Digitacao";
import Acompanhamento from "../../views/Acompanhamento/Acompanhamento";

import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import FaceOutlinedIcon from '@material-ui/icons/FaceOutlined';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import ViewCarouselOutlinedIcon from '@material-ui/icons/ViewCarouselOutlined';
import PieChartOutlinedIcon from '@material-ui/icons/PieChartOutlined';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import KeyboardOutlinedIcon from '@material-ui/icons/KeyboardOutlined';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import TrendingUpOutlinedIcon from '@material-ui/icons/TrendingUpOutlined';

import { __ADMINISTRADOR, __CANDIDATO, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL, __DIGITADOR } from '../../security/RoleConfiguration';

export const path = '/admin';

export const mainPage = '/inicio';

export const dashboardMenuList = [
    {
        category: '',
        items: [
            {
                path: `${path}/inicio`,
                name: 'Início',
                icon: HomeOutlinedIcon,
                component: Dashboard,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __CANDIDATO ],
                hide: [ __ADMINISTRADOR, __CENTRAL ],
            },
            {
                path: `${path}/inicial`,
                name: 'Início',
                icon: HomeOutlinedIcon,
                component: RedirectDashboardOrHomeAdmin,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __CANDIDATO, __COORDENADOR, __APOIO_SECRETARIAL, __DIGITADOR ],
                hide: [ __CANDIDATO, __DIGITADOR ],
            },
        ]
    },
    {
        category: 'Configurações',
        items: [
            {
                path: `${path}/contexto`,
                name: 'Contexto',
                icon: SettingsOutlinedIcon,
                component: Contexto,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL ],
                hide: [],
            },
            {
                path: `${path}/banners`,
                name: 'Banners',
                icon: ViewCarouselOutlinedIcon,
                component: Banner,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL ],
                hide: [],
            },
        ],
    },
    {
        category: 'Administração',
        items: [
            {
                path: `${path}/candidatos`,
                name: 'Candidatos',
                icon: FaceOutlinedIcon,
                component: Candidato,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL ],
                hide: [],
            },
            {
                path: `${path}/documentos`,
                name: 'Documentos',
                icon: CloudDownloadOutlinedIcon,
                component: Documento,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL ],
                hide: [],
            },
        ],
    },
    {
        category: 'Logística Reversa',
        items: [
            {
                path: `${path}/acompanhamento`,
                name: 'Acompanhamento',
                icon: TrendingUpOutlinedIcon,
                component: Acompanhamento,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL ],
                hide: [],
            },
            {
                path: `${path}/provas`,
                name: 'Provas',
                icon: DescriptionOutlinedIcon,
                component: Prova,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL ],
                hide: [],
            },            
            {
                path: `${path}/digitacao`,
                name: 'Digitação',
                icon: KeyboardOutlinedIcon,
                component: Digitacao,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL, __DIGITADOR ],
                hide: [],
            },
            {
                path: `${path}/provas/invalidas`,
                name: 'Tratamento de Provas Inválidas',
                icon: ReportProblemOutlinedIcon,
                component: ProvaInvalida,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL ],
                hide: [],
            },
        ],
    },
    {
        category: 'Comunicação',
        items: [
            {
                path: `${path}/emails`,
                name: 'Emails',
                icon: EmailOutlinedIcon,
                component: Email,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL ],
                hide: [],
            },
        ],
    },
    {
        category: 'Relatórios',
        items: [
            {
                path: `${path}/relatorio/inscricoes`,
                name: 'Inscrições',
                icon: DateRangeOutlinedIcon,
                component: RelatorioInscricoes,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL ],
                hide: [],
            },
            {
                path: `${path}/relatorio/dependencias-administrativas`,
                name: 'Dep. Administrativa',
                icon: LocalOfferOutlinedIcon,
                component: RelatorioDependenciasAdministrativas,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL ],
                hide: [],
            },
            {
                path: `${path}/relatorio/municipios`,
                name: 'Municípios de Prova',
                icon: GpsFixedOutlinedIcon,
                component: RelatorioMunicipios,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL ],
                hide: [],
            },
            {
                path: `${path}/relatorio/municipios-residenciais`,
                name: 'Municípios Residenciais',
                icon: PlaceOutlinedIcon,
                component: RelatorioMunicipiosResidenciais,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL ],
                hide: [],
            },
            {
                path: `${path}/relatorio/ufs`,
                name: "UF's",
                icon: MapOutlinedIcon,
                component: RelatorioUfs,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL ],
                hide: [],
            },
            {
                path: `${path}/relatorio/graficos`,
                name: 'Gráficos',
                icon: PieChartOutlinedIcon,
                component: Graficos,
                collapsed: false,
                submenus: [],
                roles: [ __ADMINISTRADOR, __CENTRAL, __COORDENADOR, __APOIO_SECRETARIAL ],
                hide: [],
            },
        ],
    },
];

export default dashboardMenuList;